import React from 'react';
import {getStringQueryParam} from 'utils/getQueryParam';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import {isEmbedded} from 'utils/mediafly/isEmbedded';

function showNylasResponseMessage(nylasStatus: string) {
  switch (nylasStatus) {
    case 'SUCCESS':
      return {
        type: 'success',
        message: 'Congrats! Your calendar has been successfully connected.',
      };
    case 'RETRY_LATER':
      return {
        type: 'error',
        message:
          'Sorry! An error occurred during the calendar integration process, please try again later.',
      };
    case 'INVALID_SCOPE':
      return {
        type: 'error',
        message:
          'Please retry the authentication process and ensure that you tick all the permission boxes.',
      };
    default:
      return {
        type: 'error',
        message: 'Sorry! An error occurred during the calendar integration process.',
      };
  }
}

export default function OAuthCallback() {
  const nylasStatus = getStringQueryParam(location, 'nylasStatus');

  if (nylasStatus) {
    // avoid dispatch in dispatch exception here.
    const message = showNylasResponseMessage(nylasStatus);
    return (
      <div className={cn('not-found-page')}>
        <nav className="navbar">
          <div className="left">{!isEmbedded() && <div className="logo" />}</div>
          <div className="right">
            <Button
              component="a"
              variant="outlined"
              className="learn-more"
              href="https://support.mediafly.com/hc/en-us"
              target="_blank"
              rel="noreferrer">
              Learn More
            </Button>
          </div>
        </nav>
        <div className="main">
          <h2 className="title-long">{message.message}</h2>
          <h3 className="subtitle-small">You can safely close this window</h3>
          <div className="not-found-image" />
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={window.close}
            className="ev-button">
            Close window
          </Button>
        </div>
      </div>
    );
  }
}
